import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import WordGuess from './WordGuess';
import OnScreenKeyboard from './OnScreenKeyboard';
import EndGame from './EndGame';
import Instructions from './Instructions';
// now in lambda function
// import words from "./out.json";
import { MAX_LETTERS, checkWordGuess, CheckedLetter } from './utils';
import { KeyState, KeyboardManager } from './Keyboard';

//prevents app from focusing when enter is pressed
function handleEnterKeyPress(event: KeyboardEvent) {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
}

function App() {
  // const hook = useState<string[][]>([]);
  // const guesses = hook[0];
  // const setGuesses = hook[1];

  const [guesses, setGuesses] = useState<string[][]>([[]]);
  // for testing the wordList. Now in lambda function
  // const wordList = ["pinky", "poopy", "muddy"];
  // const wordList: string[] = words["words"];
  const [todaysWord, setTodaysWord] = useState<string[]>([]);
  const [isWin, setWin] = useState(false);
  const maxGuesses = 42;
  const isLose = guesses.length > maxGuesses;
  const gameOver = isWin || isLose;
  const [isInstructionsOpen, setInstructionsOpen] = useState(false);
  // KeyboardManager has a letter and Keystate of Unused, Incorrect, Correct, WrongSpot
  const [keyboardManager, setKeyboardManager] = useState<KeyboardManager>(new KeyboardManager());

  // code for keeping new guesses scrolled to the bottom 
  const guessesEndRef = useRef<HTMLDivElement>(document.createElement('div'));

  function scrollToBottom() {
    guessesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  const instructionToggle = () => {
    setInstructionsOpen(!isInstructionsOpen);
  };
  
  const addLetter = (letter: string) => {
    if (gameOver) {
      console.log("Ignoring key press because game over");
      return;
    }
    const lastGuess = guesses[guesses.length - 1];
    if (lastGuess.length < MAX_LETTERS) {
      lastGuess.push(letter);
      setGuesses([...guesses.slice(0, guesses.length-1), lastGuess]);
    } else {
      console.log("Ignoring letter because guess too long", letter);
    }
  }

  //makes the delete button work
  const deleteLetter = () => {
    if (gameOver) {
      console.log("Ignoring key press because game over");
      return;
    }
    let lastGuess = guesses[guesses.length - 1];
    if (lastGuess.length > 0) {
      lastGuess = lastGuess.slice(0, lastGuess.length-1)
      setGuesses([...guesses.slice(0, guesses.length-1), lastGuess]);
      // console.log("lastGuess", lastGuess)
    } else {
      console.log("no letters to delete")
    }
  }

  // Left pads single digit num with a 0
  function lp(num: number) {
    if (num < 10 && num > -10) {
        return "0" + num;
    } else {
        return "" + num;
    }
  }

  //this is in the lambda function
  //selecting a random word from the word list to be the answer for the day
  const getTodaysWord = () => {
    //gets date in local time
    const d = new Date();
    //local timezone difference from minutes to milliseconds
    let diff = (d.getTimezoneOffset())*60000;
    //gets UTC time relative to local time
    const pp = d.getTime()+diff;
    //subtracts 7 hours from UTC in milliseconds
    const topdt = pp-25200000;
    const todate = new Date(topdt);
    // const utcd = todate.toISOString();
    console.log("DATE", d);
    console.log("DIFF", diff);
    console.log("TOPDT", topdt);
    console.log("TODATE", todate);
    // console.log("UTCD", utcd);
    // const year = utcd.slice(0,4);
    // const month = utcd.slice(5,7);
    // const date = utcd.slice(8,10);
    // console.log("YEAR", year, "MTH", month, "DAY", date);
    // const newd = timeChange.toISOString()
    // console.log(todate.getFullYear(), todate.getMonth()+1, todate.getDate())
    // Working URL     https://urdle-code-bucket-cc.s3.us-west-2.amazonaws.com/dailywords/2023-05-11.json
    //                 https://s3.us-west-2.amazonaws.com/urdle.app/dailywords/2023-05-14.json
    const todaysUrl = `https://s3.us-west-2.amazonaws.com/urdle.app/dailywords/${todate.getFullYear()}-${lp(todate.getMonth()+1)}-${lp(todate.getDate())}.json`
    // const todaysUrl = `https://s3.us-west-2.amazonaws.com/urdle.app/dailywords/${year+"-"+month+"-"+date}.json`
    fetch(todaysUrl)
      .then(async (response) => {
        if (response.ok) {
          console.log("response: ", response);
          const wordResponse = await response.json();
          console.log("wordResponse: ", wordResponse);
          const todaysWord = wordResponse["word"].toUpperCase().split('');
          console.log("todaysWord: ", todaysWord)
          setTodaysWord(todaysWord);
        }
      });
    // let randomWord = wordList[Math.floor(Math.random()*wordList.length)];
    // let letterArray = randomWord.toUpperCase().split('');
    // console.log("todays word", letterArray)
    // setTodaysWord(letterArray);
  }
  
  // checking whether the last guess matches the answer. Box colors logic in WordGuess.tsx
  // returns true if the guess was correct
  const checkGuess = (lastGuess: string[]): boolean => {
    console.log("lastguess", lastGuess, "todays word", todaysWord) 
    if(lastGuess.join("") == todaysWord.join("")) {  
      console.log("YOU WIN!", lastGuess);
      return true;
    } else {
      return false;
    }
  }

  //submits the current row of guesses
  const sumbitGuess = () => {
    if (gameOver) {
      console.log("Ignoring key press because game over");
      return;
    }

    let lastGuess = guesses[guesses.length - 1];
    if (lastGuess.length < MAX_LETTERS) {    
      console.log("not enough characters")
      return;
    }

    // Check keyboard keys from utils.tsx and change KeyState from Keyboard.ts
    const checked = checkWordGuess(lastGuess, todaysWord);
    for (let i=0; i<checked.length; i++) {
      const currentKeyState = keyboardManager.getKeyState(lastGuess[i]);
      if (checked[i] == CheckedLetter.Correct) {
        keyboardManager.setKeyState(lastGuess[i], KeyState.Correct);
      } else if (checked[i] == CheckedLetter.WrongSpot && currentKeyState == KeyState.Unused) {
        keyboardManager.setKeyState(lastGuess[i], KeyState.WrongSpot);
      } else if (checked[i] == CheckedLetter.Incorrect && currentKeyState == KeyState.Unused) {
        keyboardManager.setKeyState(lastGuess[i], KeyState.Incorrect);
      } else {
        console.log("ERROR in sumbitGuess keyboardManager")
      }
    }
    setKeyboardManager(keyboardManager);
    console.log("New keyboard manager", keyboardManager)

    const isCorrect = checkGuess(lastGuess);
    if (isCorrect) {
      setWin(true);
    } else {
      setGuesses([...guesses, []]);
      console.log("which guess row?", guesses)
      // console.log("submitted?", submitted);
      // element?.scrollIntoView(false);
    }
  }

  //getting todays word
  //strictmode was disabled to prevent rendering twice
  useEffect(() => {
    getTodaysWord();
    console.log("is it running twice?")
  }, []);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
    }
    document.addEventListener("keydown", handleKeyPress);
  });

  //prevents focus when enter key is clicked
  useEffect(() => {
    document.addEventListener('keypress', handleEnterKeyPress);
    return () => {
      document.removeEventListener('keypress', handleEnterKeyPress);
    };
  }, []);

  useEffect(scrollToBottom, [guesses]);

  
  const onKeyClick = (letter: string) => {
    console.log("Key clicked: ", letter)
    addLetter(letter);
  }

  const onDeleteKeyClick = () => {
    deleteLetter();
  }

  const onEnterKeyClick = () => {
    sumbitGuess();
  }

  // listthing[listthing.len][-1]
  // let guesses = [
  //   ["B","E","P","I","S"],
  //   ["P","O","O","P","Y"]
  // ]

  //keyboard code 
  
  const validLetters = ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Z", "X", "C", "V", "B", "N", "M"]
  const handleKeyDown = (event: any) => {
    let typedLetter = event.key.toUpperCase();
    // console.log('User pressed: ', typedLetter);
    if (typedLetter == "ENTER") {
      sumbitGuess();
    } else if (typedLetter == "BACKSPACE") {
      deleteLetter();
    } else if (validLetters.includes(typedLetter)) {
      addLetter(typedLetter);
    } else {
      console.log("that's not a valid letter", event.key);
    }
  };

  return (
    <html className="capture" tabIndex={-1} onKeyDownCapture={handleKeyDown}>
      <div className="App">
        {isInstructionsOpen ? <Instructions maxGuesses={ maxGuesses } onClose={ instructionToggle }/> : <button onClick={instructionToggle} className="how-to-button">How to Play</button>}
        <div className="win-state">
            <EndGame
              isLose={ isLose } 
              gameOver={ gameOver} 
              word={ todaysWord.join("") } 
              guessRows={ guesses.length }/>
        </div>
        <div className="top-background">

          <div className="square-container">
            {guesses.map((guess, i) => 
              <WordGuess guess={ guess } word={ todaysWord.join("") } submitted={ (i < guesses.length - 1 || isWin) }></WordGuess>
            )}
            <div className="scroll-to" ref={guessesEndRef}></div>
          </div>
          
        </div>
        <div className="keyboard-background">
          <OnScreenKeyboard 
            onKeyClick={onKeyClick} 
            onDeleteKeyClick={onDeleteKeyClick} 
            onEnterKeyClick={onEnterKeyClick}
            keyboardManager={keyboardManager}
            />
        </div>
      </div>
    </html>
  );
}

export default App;
